import { QElement } from "./QElement";

export class QElementGroup {
  constructor() {
    this.fElements = null;
    //	this.fPanel = null;
  }

  InitGroup() {
    //this.fPanel = thePanel;
  }

  GetElementCount() {
    var l = 0;
    if (this.fElements) l = this.fElements.length;

    return l;
  }

  SortGroup() {
    // Override this
  }

  GetIndexElement(theIndex) {
    if (this.fElements == null) return null;

    return this.fElements[theIndex];
  }

  SelectElements(parentPanel, select) {
    var n = this.GetElementCount();
    for (var i = 0; i < n; i++) {
      var anElement = this.GetIndexElement(i);
      parentPanel.DoSelectElement(anElement, select);
      //anElement.SetSelected(select); // Doublecheck
    }
  }

  IndexOfElement(anElement) {
    var index = this.fElements.indexOf(anElement);
    return index;
  }

  // Private - Use SetElementGroup
  PAddElementToGroup(anElement) {
    if (this.fElements == null) this.fElements = new Array();

    this.fElements.push(anElement);

    this.SortGroup();
  }

  // Private - Use SetElementGroup
  PRemoveElementFromGroup(anElement) {
    var index = this.fElements.indexOf(anElement);
    if (index != -1) {
      this.fElements.splice(index, 1);
      return true;
    }

    return false;
  }

  // If parentPanel is null all elements are removed from group but still remain in panel
  ClearGroup(parentPanel, baseElement) {
    if (this.fElements == null) return;

    var n = this.fElements.length - 1;
    for (var i = n; i >= 0; i--) {
      var anElement = this.fElements[i];
      if (anElement != baseElement) {
        if (parentPanel == null) anElement.SetElementGroup(null);
        else parentPanel.RemoveElement(anElement);
      }
    }
  }
}
